<template>
  <v-tooltip
    top
    :offset="4"
    nudge-right="5"
    content-class="custom-tooltip"
   
  >
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        color="primary"
        v-bind="attrs"
        v-on="on"
        class="info-icon"
        aria-label="More information"
      >
        mdi-information
      </v-icon>
    </template>
    <span>
     <b> {{ textInitial }} </b> 
      <ul>
        <li v-for="(item, index) in listItems" :key="index">
          {{ item }}
        </li>
      </ul>
    </span>
  </v-tooltip>
</template>

<script>
export default {
  name: "CpTooltipList",
  props: {
    listItems: {
      type: Array,
      default: () => [],
    },
    textInitial: {
      type: String,
      default: "",
    },
    colorIcon: {
      type: String,
      default: "#00A5FF",
    },
  },
  data() {
    return {
      isTooltipVisible: true, // Control visibility state
    };
  },
};
</script>
<style scoped>
.info-icon {
  cursor: pointer;
  margin: 0 8px;
  transition: opacity 0.2s;
}

.info-icon:hover {
  opacity: 0.8;
}
.v-icon.v-icon{
  font-size: 16px;
}
/* Custom tooltip styling */
 .custom-tooltip {
  background: #FFFFFF;
  box-shadow: 0px 2px 6px rgba(107, 115, 139, 0.2);
  border-radius: 6px;
  color: #6B738B; /* Dark text color */
  padding: 12px 16px;
  font-size: 11px;
  line-height: 1.5;
  font-weight: 400;
}

/* .custom-tooltip ul {
  margin: 8px 0 0 0;
  padding-left: 20px;
}

.custom-tooltip li {
  margin-bottom: 4px;
} */
</style>
